<template>
  <div>
    <v-navigation-drawer
      disable-resize-watcher
      class="mobileShow"
      v-model="drawerData"
      :clipped="clipped"
      fixed
      app
    >
      <v-list expand :style="{ 'align-items': 'center' }">
        <v-list-tile to="/">
          <v-list-tile-action>
            <v-icon>fas fa-tachometer-alt</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-black.font-italic"
            >SmartLogistics</v-list-tile-title
          >
        </v-list-tile>
        <!--Operatori-->
        <v-list-group
          prepend-icon="fas fa-folder-open"
          :value="false"
          no-action
          v-if="isOperator"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>{{
                $t("header.MenuOperatori")
              }}</v-list-tile-title>
            </v-list-tile>
          </template>
          <template>
            <v-list-group
              prepend-icon="fas fa-folder-open"
              :value="false"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>
                    {{ $t("header.GestioneEntità") }}
                  </v-list-tile-title>
                </v-list-tile>
              </template>
              <v-list-tile to="/Users/Index">
                <v-list-tile-title>{{ $t("header.Utente") }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/Stocks/Index">
                <v-list-tile-title>{{ $t("header.Sito") }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/Customers/Index">
                <v-list-tile-title>
                  {{ $t("header.Committente") }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list-group>
            <v-list-group
              prepend-icon="fas fa-folder-open"
              :value="false"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>
                    {{ $t("header.GestioneEstrazioni") }}
                  </v-list-tile-title>
                </v-list-tile>
              </template>
              <v-list-tile to="/Extractions/Index">
                <v-list-tile-title>
                  {{ $t("header.Estrazioni") }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list-group>
            <v-list-group
              prepend-icon="fas fa-folder-open"
              :value="false"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>
                    {{ $t("header.Mappature") }}
                  </v-list-tile-title>
                </v-list-tile>
              </template>
              <v-list-tile to="/UsersCustomers/Index">
                <v-list-tile-title>
                  {{ $t("header.UtenteCommittente") }}
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/UsersExtractions/Index">
                <v-list-tile-title>
                  {{ $t("header.UtenteEstrazioni") }}
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/UsersOperations/Index">
                <v-list-tile-title>
                  {{ $t("header.UtenteOperazioni") }}
                </v-list-tile-title>
              </v-list-tile>
            </v-list-group>
          </template>
        </v-list-group>
        <!--Utenti-->
        <v-list-group
          prepend-icon="fas fa-folder-open"
          :value="false"
          no-action
          v-if="isOperator"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>
                {{ $t("header.MenuUtenti") }}
              </v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-group
            prepend-icon="fas fa-folder-open"
            :value="false"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>
                  {{ $t("header.Estrazioni") }}
                </v-list-tile-title>
              </v-list-tile>
            </template>

            <v-list-group
              prepend-icon="fas fa-folder-open"
              :value="false"
              no-action
              v-for="(ec, index) in extractionsCategory"
              :key="index"
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>
                    <v-list-tile-action>{{ ec }}</v-list-tile-action>
                  </v-list-tile-title>
                </v-list-tile>
              </template>

              <v-list-tile
                v-for="e in filterExtractions(ec)"
                :key="e.id"
                @click="navToExtraction(e)"
              >
                <v-list-tile-title v-text="e.name">
                  <v-list-tile-action>{{ e.name }}</v-list-tile-action>
                </v-list-tile-title>
              </v-list-tile>
            </v-list-group>
          </v-list-group>
          <v-list-group
            prepend-icon="fas fa-folder-open"
            :value="false"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>
                  {{ $t("header.Operazioni") }}
                </v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile v-for="o in operations" :key="o.id" :to="o.controller">
              <v-list-tile-title>
                <v-list-tile-action>{{ o.description }}</v-list-tile-action>
              </v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      :clipped-left="clipped"
      fixed
      app
      dense
      dark
      color="#222d32"
      class="fercamColor"
    >
      <a href="/" class="applicationButton">
        <b class="stylePaddingHeader">Smart</b>Logistics
      </a>
      <v-toolbar-side-icon
        class="mobileShow"
        @click="drawerData = !drawerData"
      />
      <v-toolbar-title class="headline mr-5" v-text="title" />

      <!--Operatori-->
      <hsc-menu-style-white class="desktopShow" v-if="isOperator">
        <hsc-menu-bar class="mnuBtn">
          <hsc-menu-bar-item
            flat
            :label="$t('header.MenuOperatori')"
            class="v-btn v-btn__content white--text"
          >
            <hsc-menu-item :label="$t('header.GestioneEntità')" class="">
              <hsc-menu-item
                @click="navigateTo('/Users/Index')"
                :label="$t('header.Utente')"
                class=""
              />
              <hsc-menu-item
                @click="navigateTo('/Stocks/Index')"
                :label="$t('header.Sito')"
                class=""
              />
              <hsc-menu-item
                @click="navigateTo('/Customers/Index')"
                :label="$t('header.Committente')"
                class=""
              />
            </hsc-menu-item>
            <hsc-menu-item :label="$t('header.GestioneEstrazioni')" class="">
              <hsc-menu-item
                @click="navigateTo('/Extractions/Index')"
                :label="$t('header.Estrazioni')"
                class=""
              />
            </hsc-menu-item>
            <hsc-menu-item :label="$t('header.Mappature')" class="">
              <hsc-menu-item
                @click="navigateTo('/UsersCustomers/Index')"
                :label="$t('header.UtenteCommittente')"
                class=""
              />
              <hsc-menu-item
                @click="navigateTo('/UsersExtractions/Index')"
                :label="$t('header.UtenteEstrazioni')"
                class=""
              />
              <hsc-menu-item
                @click="navigateTo('/UsersOperations/Index')"
                :label="$t('header.UtenteOperazioni')"
                class=""
              />
            </hsc-menu-item>
          </hsc-menu-bar-item>
        </hsc-menu-bar>
      </hsc-menu-style-white>

      <!--Utenti-->
      <hsc-menu-style-white class="desktopShow" v-if="isUser">
        <hsc-menu-bar class="mnuBtn">
          <hsc-menu-bar-item
            :label="$t('header.MenuUtenti')"
            class="v-btn v-btn__content white--text"
          >
            <hsc-menu-item :label="$t('header.Estrazioni')" class="">
              <hsc-menu-item
                class=""
                v-for="(ec, index) in extractionsCategory"
                :key="index"
                :label="ec"
              >
                <hsc-menu-item
                  v-for="e in filterExtractions(ec)"
                  :key="e.id"
                  :label="e.name"
                  @click="navToExtraction(e)"
                  class=""
                />
              </hsc-menu-item>
            </hsc-menu-item>

            <hsc-menu-item :label="$t('header.Operazioni')" class="">
              <hsc-menu-item
                class=""
                v-for="o in operations"
                :key="o.id"
                @click="navToOperation(o)"
                :label="
                  currentLanguage == 'it' ? o.description : o.descriptionEN
                "
              />
            </hsc-menu-item>
          </hsc-menu-bar-item>
        </hsc-menu-bar>
      </hsc-menu-style-white>
      <v-spacer />

      <!-- <v-menu>
        <v-btn icon slot="activator">
          <v-icon>person</v-icon>
        </v-btn>
        <v-list class="marginMenu">
          <v-list-tile v-if="$GAUserAuth.user.isAuthenticated">
            <v-list-tile-avatar>
              <v-icon>person</v-icon>
              <span class="white--text headline">{{ userName }}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{
                $GAUserAuth.user.username
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>

          <v-list-tile v-if="!$GAUserAuth.user.isAuthenticated" @click="login">
            <v-list-tile-action>
              <v-icon>fas fa-sign-in-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Login</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-else @click="logout">
            <v-list-tile-action>
              <v-icon>fas fa-sign-out-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu> -->

      <v-menu>
        <v-btn flat slot="activator">
          <img :src="require('../assets/' + currentLanguage + '.png')" />
          &nbsp;
          {{ $t("header.Lingua") }}
        </v-btn>

        <v-list class="marginMenu">
          <v-list-tile
            v-for="(item, index) in supportedLanguages"
            :key="index"
            @click="changeLanguage(item.code, true)"
          >
            <v-list-tile-avatar :tile="true">
              <img :src="require('../assets/' + item.code + '.png')" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
  </div>
</template>

<script>
import usersApi from "../apiSmartLogistics/usersApi";
import { Trans } from "@/plugins/Translation";
export default {
  props: {
    clipped: Boolean,
    drawer: Boolean,
    fixed: Boolean,
    items: Array,
    title: String,
    userName: String,
    refresh: Boolean,
  },

  async created() {
    // todo: pass the logged user's mail
    //await this.$GAUserAuth.refreshUserInfo()
    // eslint-disable-next-line
    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      this.$GAUserAuth.canRead("Menu Operatore").then((r) => {
        this.isOperator = r;
      });

      // todo: pass the logged user's mail
      this.$GAUserAuth.canRead("Menu Utente").then((r) => {
        this.isUser = r;
      });

      this.getUserOperations();
      this.getUserExtractions();
    });
  },
  mounted: function () {
    this.drawerData = false;
  },
  data() {
    return {
      drawerData: this.drawer,
      operations: [],
      extractions: [],
      extractionsCategory: [],
      //displayHomePagebtn: false
      isUser: false,
      isOperator: false,
    };
  },

  computed: {
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    },
  },

  methods: {
    updateMenu() {
      this.getUserOperations();
      this.getUserExtractions();
    },
    getUserOperations() {
      usersApi
        .GetUserOperations(this.$GAUserAuth.user.username)
        .then((response) => {
          this.operations = response.data;
        });
    },
    getUserExtractions() {
      usersApi
        .GetUserExtractions(this.$GAUserAuth.user.username)
        .then((response) => {
          this.extractions = response.data;
          this.extractionsCategory = [
            ...new Set(this.extractions.map((x) => x.description)),
          ];
        });
    },
    isCurrentLanguage(lang) {
      return lang === this.currentLanguage;
    },
    changeLanguage(lang, save) {
      if (save) {
        localStorage.setItem("Language", lang);
      }
      const to = this.$router.resolve({ params: { lang } });
      return Trans.changeLanguage(lang).then(() => {
        this.$router.push(to.location);
      });
    },

    filterExtractions(ec) {
      var filteredExtractions = this.extractions.filter(function (el) {
        return el.description == ec;
      });
      return filteredExtractions;
    },
    navToOperation: function (e) {
      this.navigateTo(e.controller);
    },
    navToExtraction: function (e) {
      this.navigateTo("/Extractions/View/" + e.id);
    },
    navigateTo: function (a) {
      location.href = "/" + this.currentLanguage + a;
    },
    async login() {
      await this.$GAUserAuth.signin();
    },
    async logout() {
      await this.$GAUserAuth.signout();
    },
  },
};
</script>

<style>
/* .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: none;
} */
/* .v-btn:not(.v-btn--depressed):not(.v-btn--flat) :hover {
  background-color: #279947;
} */

.font-weight-bold {
  color: white !important;
}

.font-weight-thin.font-italic {
  color: white !important;
}

.highlighted {
  color: lightgray !important;
}
.mobileShow {
  display: none !important;
}
.desktopShow {
  display: block;
}
.marginMenu {
  margin-top: 5vh;
}
@media (max-width: 600px) {
  .mobileShow {
    display: block !important;
  }
  .desktopShow {
    display: none !important;
  }
}
.subMenu {
  position: absolute;
  left: 120px;
  top: 0px;
}
.v-menu__content {
  contain: initial !important;
  overflow-y: initial;
  overflow-x: initial;
}
.mnuBtn {
  background-color: rgba(0, 0, 0, 0) !important;
  color: white;
  box-shadow: rgba(255, 255, 255, 0) 0px 0px 0pt !important;
  display: table;
  font-family: unset !important;
  padding: 1 !important;
  user-select: none;
  cursor: default;
  margin-bottom: 1px;

  border-radius: 0 !important;
}
.menu {
  background-color: #5d6367 !important;
  color: white !important;
  border-radius: 0 !important;
}
.mnuLst {
  border-radius: 0 !important;
  background-color: #5d6367 !important;
}
.logo-container {
  max-width: 200px;
  max-height: 48px;
  overflow: hidden;
  display: inline-block;
  line-height: 48px;
  font-size: 0;
  vertical-align: top;
  margin-right: 4vw;
  margin-left: 4vw !important;
}
.logo {
  max-width: 200px;
  max-height: 30px;
  border-style: none !important;
  vertical-align: middle;
}
.separator {
  align-self: center;
  background-color: currentColor;
  margin-left: 16px;
  margin-right: 16px;
  height: 28px;
  width: 1px;
  background-color: white;
}

.applicationButton {
  color: white !important;
  text-decoration: none !important;
  vertical-align: middle;
  font-weight: 600;
  font-family: SegoeUI-SemiBold-final, Segoe UI Semibold, SegoeUI-Regular-final,
    Segoe UI, "Segoe UI Web (West European)", Segoe, -apple-system,
    BlinkMacSystemFont, Roboto, Helvetica Neue, Tahoma, Helvetica, Arial,
    sans-serif;
  font-size: 16px !important;
  line-height: 48px;
  -webkit-font-smoothing: antialiased;
}

.mobileShow {
  display: none !important;
}
.desktopShow {
  display: block;
}
.marginMenu {
  margin-top: 5vh;
}
@media (max-width: 600px) {
  .mobileShow {
    display: block !important;
  }
  .desktopShow {
    display: none !important;
  }
}

.v-menu__content {
  contain: initial !important;
  overflow-y: initial;
  overflow-x: initial;
}
.mnuBtn {
  background-color: rgba(0, 0, 0, 0) !important;
  color: white;
  box-shadow: rgba(255, 255, 255, 0) 0px 0px 0pt !important;
  display: table;
  font-family: unset !important;
  padding: 1 !important;
  user-select: none;
  cursor: default;
  margin-bottom: 1px;

  border-radius: 0 !important;
}
.menu {
  background-color: #424242 !important;
  color: white !important;
  border-radius: 0 !important;
}
.mnuLst {
  border-radius: 0 !important;
  background-color: #424242 !important;
}
</style>
